import React from 'react';
import './UserInfo.scss';
import { Icon, Divider } from 'antd';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {  
  userInfo: Julius.Website.CustomerInfoViewModel;
  onLogout: () => void;
  onUpdateAccount: () => void;
  onUpdatePassword: () => void;
  onGoToTickets: () => void;
}

const UserInfo: React.SFC<IProps> = ({
  userInfo: {
    firstName,
    lastName,
    email,
    phone,
    street,
    zipcode,
    city,
    country,
    company,
  },
  onLogout,
  onUpdateAccount,
  onUpdatePassword,
  onGoToTickets,
}) => (
  <div className='user-info'>
    <div className='top-area'>
      { firstName && firstName.length && lastName && lastName.length &&
        <div className='user-name'>
          { `${firstName} ${lastName}` }
        </div>
      }
      <div>
        { email && email.length && 
          <div className='info-item'>
            <Icon type='mail' />{ email }
          </div>
        }
        { phone && phone.length && 
          <div className='info-item'>
            <Icon type='phone' />{ phone }
          </div>   
        }
        { street && street.length && zipcode && zipcode.length && 
          city && city.length && country && country.length && 
          <div className='info-item'>
            <Icon type='home' />
            <span>
              <div>{ street }</div>
              <div>{ `${ zipcode } ${ city }, ${ country }` }</div>
            </span>
          </div>
        }
        { company &&
          <div className='info-item'>
            <Icon type='idcard' />{ company }
          </div>   
        }
      </div>
    </div>
    <Divider />
    <div className='bottom-area'>
      <div  onClick={ onGoToTickets }>
        <Icon type='tags-o' />
        <FormattedText 
          displayName='Se mina bokningar'
          formattedName='user.seetickets'
        />
      </div>
      <div onClick={ onUpdateAccount }>
        <Icon type='edit' />
        <FormattedText 
          displayName='Ändra kunduppgifter'
          formattedName='user.changeinfo'
        />
      </div>
      <div onClick={ onUpdatePassword }>
        <Icon type='lock' />
        <FormattedText 
          displayName='Ändra lösenord'
          formattedName='user.changepassword'
        />
      </div>
      <div onClick={ onLogout }>
        <Icon type='logout' />
        <FormattedText 
          displayName='Logga ut'
          formattedName='user.logout'
        />
      </div>
    </div>
  </div>
);

export default UserInfo;


// WEBPACK FOOTER //
// ./src/components/MenuUser/UserInfo/UserInfo.tsx